<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-refresh [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/actions')"></med-icon-refresh></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.showActionsFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
        <div style="width: 100%;">
            <med-multi-select
                    size="small"
                    [hideClearBtn]="true"
                    placeholder="{{ !filter.actions.actionTypes.length ? 'Всі': 'Обрано фільтрів: ' + filter.actions.actionTypes.length }}"
                    label="Тип дії"
                    [options]="filter.actionOptions.actionTypes"
                    [(ngModel)]="filter.actions.actionTypes"
                    (ngModelChange)="filter.actionsStateChanged()"
            ></med-multi-select>
        </div>
        <div style="width: 100%;">
            <med-datepicker
                    size="small"
                    [mode]="'range'"
                    label="Дата"
                    placeholder="Оберіть дату"
                    [(ngModel)]="filter.actions.createdAt"
                    (ngModelChange)="filter.actionsStateChanged()"
            ></med-datepicker>
        </div>
        <div style="width: 100%;">
            <med-input
                    size="small"
                    [hideClearBtn]="true"
                    placeholder="Ініціатор"
                    label="Ініціатор"
                    [(ngModel)]="filter.actions.initiator[0]"
                    (focusout)="filter.actionsStateChanged()"
            ></med-input>
        </div>
      <med-btn (click)="downloadExcel()">
        <med-icon-download></med-icon-download>
        Експорт в xls
      </med-btn>
    </div>
  </div>
</p-sidebar>

<app-page-title></app-page-title>

<app-loader [hidden]="loadingCounter === 0"></app-loader>
<div class="table-wrapper" [hidden]="loadingCounter > 0">
  <p-table
    #dt
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="tableBody"
    [customSort]="true"
    [lazy]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [columns]="tabHeaderActions"
    [reorderableColumns]="true"
    (onColResize)="handleColumnResize($event)"
    (onLazyLoad)="loadData($event, true)"
    (onColReorder)="saveColumnOrder()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key"  [pSortableColumnDisabled]="column.key === 'directions' || column.key === 'subdirections' || column.key === 'name'" pReorderableColumn pResizableColumn
            *ngFor="let column of tabHeaderActions" style="min-width: 10em">
          <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['deliveryDate'].includes(column.key) ? '14em': 'initial', 'width': ['deliveryDate'].includes(column.key) ? '10em': column.width}" [ngClass]="{'no-wrap': ['deliveryDate'].includes(column.key)}">
            {{ column.label }}&nbsp;
            <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-action let-columns="columns">
      <tr class="table-content-text">
        <ng-container *ngFor="let col of columns">
          <td style="word-break: keep-all; white-space: nowrap;" class="black-80 h10-text" *ngIf="col.key === 'actionType'">{{ action.actionType }}</td>
          <td style="word-break: keep-all; white-space: nowrap;" class="black-60 h10-text" *ngIf="col.key === 'createdAt'">{{ action.createdAt | date: 'dd.MM.yyyy, HH:mm:ss' }}</td>
          <td style="word-break: keep-all; white-space: nowrap;" class="black-80 h10-text" *ngIf="col.key === 'initiator'">{{ action.initiator }}</td>
          <td style="word-break: keep-all; white-space: nowrap;" class="black-80 h10-text" *ngIf="col.key === 'actionObject'">
            <a [href]="getHref(action.actionObject)">{{getEntityName(action.actionObject)}}</a>

          </td>
          <td style="word-break: keep-all; white-space: nowrap;" class="black-60 h10-text" *ngIf="col.key === 'details'">{{ action.details }}</td>
          <td style="word-break: keep-all; white-space: nowrap; color: #333333" *ngIf="col.key === 'statusBefore'">
            <div class="h10-text" style="display: flex; flex-direction: row; width: 18em" *ngIf="action.statusBefore && 'Статус відсутній' !== action.statusBefore"><img [src]="getPathToStatusImg(action.statusBefore)" width="4" height="16" style="vertical-align: middle;" />&nbsp; {{statusTranslatorService.getStatusForString(action.statusBefore)}}</div>
          </td>
          <td style="word-break: keep-all; white-space: nowrap; color: #333333" *ngIf="col.key === 'statusAfter'">
            <div class="h10-text" style="display: flex; flex-direction: row; width: 18em" *ngIf="action.statusAfter && 'Статус відсутній' !== action.statusAfter"><img [src]="getPathToStatusImg(action.statusAfter)" width="4" height="16" style="vertical-align: middle;" />&nbsp; {{statusTranslatorService.getStatusForString(action.statusAfter)}}</div>
          </td>
          <td style="word-break: keep-all; white-space: nowrap; color: #333333" *ngIf="col.key === 'destination'">{{ action.destination }}</td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRows"
          [page]="selectedPageNumber"
          [perPage]="pageSize"
          (pageChange)="pageChange($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<span style="color: #000000" class="h10-text">{{ getFirstShowedRowIndex() }}-{{ getFirstShowedRowIndex() + pageSize }}</span> &nbsp;з {{ totalRows }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="showedOnPage"
            [options]="paginationOptions"
            (onInput)="pageSizeChanged($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>
  </p-table>
</div>
